import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { api } from "../../lib/api";
import { PlannerCard } from "../../pages/PlannerPages";

export default function FeaturedPlanners() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/public/planners", { params: { featured: true, limit: 6 } }).then((r) => setRows(r.data.slice(0, 3))).catch(() => {}); }, []);
  return (
    <section className="px-6 md:px-12 pt-20 max-w-7xl mx-auto" data-testid="home-featured-planners">
      <div className="flex flex-wrap items-end gap-4 mb-6">
        <div className="flex-1 min-w-[240px]"><p className="font-script text-[var(--gold)] text-3xl">Need a hand?</p><h2 className="font-serif font-light text-4xl">Find a wedding planner</h2>
          <p className="text-sm text-[#5c544b] mt-1 max-w-lg">Real weddings, couple reviews and the vendors they trust, all in one place.</p></div>
        <Link to="/planners" className="btn-outline-gold" data-testid="home-planners-link"><Compass className="w-4 h-4" />Browse planners</Link>
      </div>
      {rows.length > 0 && <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{rows.map((p) => <PlannerCard key={p.slug} p={p} />)}</div>}
    </section>
  );
}
